module.exports = __webpack_public_path__ + "static/media/16UNODC6.6010a0ea.jpg";